import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var ExperienceTimeoutError = /*#__PURE__*/function (_Error) {
  function ExperienceTimeoutError(message) {
    var _this;
    _classCallCheck(this, ExperienceTimeoutError);
    _this = _callSuper(this, ExperienceTimeoutError, [message]);
    _this.name = 'ExperienceTimeoutError';
    return _this;
  }
  _inherits(ExperienceTimeoutError, _Error);
  return _createClass(ExperienceTimeoutError);
}( /*#__PURE__*/_wrapNativeSuper(Error));